import { render } from "./ReportPage.vue?vue&type=template&id=789ab2dd&ts=true"
import script from "./ReportPage.vue?vue&type=script&lang=ts"
export * from "./ReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__